import { useEffect, useState } from 'react';
import { Moon, Sun } from 'lucide-react';

export default function ThemeToggle() {
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const stored = localStorage.getItem('theme') || 'light';
    setTheme(stored);
    applyTheme(stored);
  }, []);

  function applyTheme(mode) {
    const root = document.documentElement;
    const useDark = mode === 'dark';
    root.classList.toggle('dark', useDark);
  }

  function cycleTheme() {
    const next = theme === 'light' ? 'dark' : 'light';
    setTheme(next);
    localStorage.setItem('theme', next);
    applyTheme(next);
  }

  const label = theme === 'light' ? 'Light' : 'Dark';

  return (
    <button
      onClick={cycleTheme}
      className="inline-flex items-center gap-2 px-3 py-2 rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 text-sm dark:bg-gray-800 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-700"
      title={`Theme: ${label}`}
      aria-label={`Toggle theme (current: ${label})`}
    >
      {theme === 'dark' ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
      <span className="hidden sm:inline">{label}</span>
    </button>
  );
} 